import * as React from "react";
import { GlobalSearchResultModel } from "../model/autogen/GlobalSearchResultModel";
import { isEmptyResultSet } from "../components/global-search-result-list";
import { Content } from "../components/content";
import { Typography, LinearProgress } from "@material-ui/core";
import { Iif } from "../components/iif";
import { IFetcher } from "../components/with-auth-context";
import { SearchRequestFactory } from "../model/autogen/SearchController";
import { appendResults, hasMoreResults, getCurrentTotal } from "../utils/search-result";
import { GlobalAdvancedSearchInputModel } from "../model/autogen/GlobalAdvancedSearchInputModel";

export function hasResults(results: GlobalSearchResultModel) {
    return !isEmptyResultSet(results)
}

export const NoResults = (props: any) => <Content>
    <Typography variant="h6">No results found. Try refining your criteria</Typography>
</Content>;

export const Searching = (props: any) => <Content>
    <Typography variant="h6">Searching ...</Typography>
    <LinearProgress />
</Content>;

export interface IInfiniteListLoading {
    isSearching: boolean;
    startAt: number | undefined;
    results: GlobalSearchResultModel | undefined;
    children: any;
}

export const InfiniteListLoading = (props: IInfiniteListLoading) => {
    const { isSearching, startAt, results } = props;
    return <Iif show={!isSearching || startAt !== undefined} else={<Searching />}>
        <Iif show={!!results}>
            <Iif show={hasResults(results!)} else={<NoResults />}>
                {props.children}
            </Iif>
        </Iif>
    </Iif>
}

export interface InfiniteScrollerProps {
    deletedOnly?: boolean;
    showSnackbarMessage: (message: string) => void;
    callApi: <T>(serviceMethod: (fetcher: IFetcher) => Promise<T>) => Promise<T>;
}

export interface InfiniteScrollerState {
    isSearching: boolean;
    results: GlobalSearchResultModel | undefined;
    hasMore?: boolean;
    startAt?: number;
}

function isStartGreaterThanZero(val: number | undefined) {
    if (typeof(val) != 'undefined') {
        return val > 0;
    }
    return false;
}

export class InfiniteScrollerHelper {
    constructor(private getState: () => InfiniteScrollerState, private setState: (newState: InfiniteScrollerState, callback?: () => void) => void, private getProps: () => InfiniteScrollerProps) {

    }
    getInitialState(documentTypes?: string[]): GlobalAdvancedSearchInputModel {
        return {
            from: null,
            to: null,
            query: "",
            documentTypes: documentTypes || [],
            tags: [],
            quoteAuthor: undefined,
            quoteSubjects: [],
            quoteAuthoredSubject: undefined,
            tweetAuthor: undefined,
            tweetMentions: [],
            tweetAuthoredMention: undefined
        }
    }
    fetchMoreResults() {
        const { isSearching, hasMore, results } = this.getState();
        if (isSearching) {
            return;
        }
        if (hasMore === true && results) {
            var startCount = getCurrentTotal(results);
            this.performSearch(startCount)
        }
    }
    performSearch(startingCount?: number) {
        const { isSearching, results: before, ...rest } = this.getState();
        const { documentTypes, query, tags, from, to, startAt, quoteAuthor, quoteAuthoredSubject, quoteSubjects, tweetAuthor, tweetAuthoredMention, tweetMentions } = (rest as any);
        const payload = {
            documentTypes,
            query,
            tags,
            from,
            to,
            startAt,
            quoteAuthor,
            quoteAuthoredSubject,
            quoteSubjects,
            tweetAuthor,
            tweetAuthoredMention,
            tweetMentions,
        };
        //const before = JSON.stringify(this.state.results);
        //const before = this.state.results;
        
        this.setState({ isSearching: true, results: payload.startAt == 0 ? undefined : before }, async () => {
            const obj: GlobalAdvancedSearchInputModel = { ...payload, startAt: startingCount };
            const { deletedOnly, callApi, showSnackbarMessage } = this.getProps();
            try {
                const action =  deletedOnly === true
                    ? (fetcher: IFetcher) => SearchRequestFactory.findAdvancedDeleted(fetcher, obj)
                    : (fetcher: IFetcher) => SearchRequestFactory.findAdvanced(fetcher, obj);
                const newResults = await callApi(action);
                this.setState({
                    isSearching: false,
                    results: isStartGreaterThanZero(startingCount) ? appendResults(before, newResults) : newResults,
                    startAt: 1, // we set startAt to a none undefined value so searcher knows not to clear all results
                    hasMore: hasMoreResults(newResults)
                });
            } catch (e) {
                showSnackbarMessage("An error occurred performing the search");
                this.setState({
                    isSearching: false,
                    results: before,
                    startAt: 1,// we set startAt to a none undefined value so searcher knows not to clear all results
                    hasMore: hasMoreResults(before)
                });
            }
        });
    }
}




// WEBPACK FOOTER //
// ./src/pages/infinite-scroller-helper.tsx